import React, { createContext, useContext, type RefObject } from 'react';

interface LayoutContextType {
  containerRef?: RefObject<HTMLDivElement|null>;
  safeAreaTop?: number;
  safeAreaBottom?: number;
  isDarkMode?: boolean;
  // 可以继续添加更多变量...
}

const LayoutContext = createContext<LayoutContextType>({});

export const LayoutProvider: React.FC<{
  children: React.ReactNode;
  containerRef: RefObject<HTMLDivElement|null>;
  safeAreaTop?: number;
  safeAreaBottom?: number;
  isDarkMode?: boolean;
}> = ({ children, containerRef, safeAreaTop, safeAreaBottom, isDarkMode }) => {
  return (
    <LayoutContext.Provider value={{ containerRef, safeAreaTop, safeAreaBottom, isDarkMode }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within LayoutProvider');
  }
  return context;
};
